import { Breakpoints } from '@fukku/styles/breakpoints'

export function usePictureSources() {
	const mediaSmall = `(max-width: ${Breakpoints.medium}px)`
	const mediaMedium = `(min-width: ${Breakpoints.medium}px)`
	const mediaLarge = `(min-width: ${Breakpoints.large}px)`
	return { mediaSmall, mediaMedium, mediaLarge }
}
